import { Modal, ModalHeader, ModalBody, ModalFooter, Button, Row, Col, FormGroup } from "reactstrap";
import "../../assets/css/EnquiryModal.css"

export default function EnquiryModal({
    isOpen,
    toggle,
    items = [],
    remark,
    setRemark,
    onRemoveItem,
    onSubmit,
    submitting = false,
    title = "Product Enquiry"
}) {
    return (
        <Modal isOpen={isOpen} toggle={toggle} size="lg" centered>
            <ModalHeader toggle={toggle} className="bg-white"> {title} ({items.length} items) </ModalHeader>

            <ModalBody className="bg-white">
                <Row className="enquiry-card-row">
                    {items.map(item => (
                        <Col md={6} lg={6} key={item.Style_ID} className="mb-2">
                            <div className="card border-2 shadow-sm h-100 position-relative bg-white rounded enquiry-card">
                                {items.length > 1 && (
                                    <Button color="link" className="position-absolute top-0 end-0 p-1 m-0" onClick={() => onRemoveItem(item.Style_ID)}> ✕ </Button>
                                )}
                                <div className="card-body">
                                    <p className="fw-bold mb-1 text-truncate enquiry-card-title text-primary" title={item.Shortdescription} > {item.Shortdescription} </p>
                                    <p className="mb-2 enquiry-card-ProductCode"> Product Code: {" "} <span className="fw-normal">{item.StyleNo} / {item.JewelCode}</span> </p>
                                    <p className="mb-1 enquiry-card-ProductDetail"> Purity:{" "} <span className="fw-normal">{item.MetalQuality} / {item.MetalTone} </span> </p>
                                    <p className="mb-0 enquiry-card-ProductDetail"> Gold Weight:{" "} <span className="fw-normal">{item.TotalNetWt}</span> </p>
                                </div>
                            </div>
                        </Col>
                    ))}
                </Row>
                <div className="Enquiry-form mt-2">
                    <FormGroup>
                        <label className="form-label">Remark:</label>
                        <textarea
                            className="form-control bg-white border-2 shadow-sm"
                            rows="3"
                            placeholder="Additional information or remarks..."
                            value={remark}
                            onChange={(e) => {
                                const value = e.target.value
                                    .replace(/[^a-zA-Z0-9\s]/g, "")
                                if (value.length <= 50) {
                                    setRemark(value);
                                }
                            }}
                        />
                        <small className="text-muted">
                            {remark.length}/50 characters
                        </small>
                    </FormGroup>
                </div>
            </ModalBody>

            <ModalFooter className="bg-white">
                <Button color="secondary" onClick={toggle}> Cancel </Button>
                <Button color="primary"
                    onClick={onSubmit} disabled={submitting || items.length === 0} > {submitting ? "Submitting..." : "Submit Enquiry"}
                </Button>
            </ModalFooter>
        </Modal>
    );
}
